import React, { Fragment } from "react";
import { Link } from 'react-router-dom';


const Description = ()=> {

  return (
    <Fragment>
      <div className="description-overlay">
        <h5> Bring one friend to EarnDorad </h5>
        <p> Each user that will register to EarnDorado through your referral link will bring you up to <strong>300</strong> points. </p>
      </div>
      <Link className="btn action btn-primary" to={"/referrals"}>Invite</Link>
    </Fragment>
  );
};

export default Description;
